module.exports = __webpack_public_path__ + "static/media/ic_random_act.356af134.svg";